import Documents from './Documents';
import LoggedOut from './LoggedOut';
import Logout from './Logout';
import OidcCallback from './OidcCallback';
import Profile from './Profile';
import RemoteLogout from './RemoteLogout';

export default {
  Documents,
  Profile,
  LoggedOut,
  Logout,
  OidcCallback,
  RemoteLogout
}